(function () {
  'use strict';

  var SELECTOR = '[data-ibf-god-rays]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function createRays(canvas) {
    if (!canvas || canvas.dataset.ibfRaysReady === 'true') return;

    canvas.style.visibility = 'hidden';
    var footer = canvas.closest('.ibf');
    var context = canvas.getContext('2d', { alpha: true });
    if (!footer || !context) return;

    canvas.dataset.ibfRaysReady = 'true';

    var frame = 0;
    var visible = false;
    var mobile = window.matchMedia('(max-width: 749px)');
    var lastPaint = 0;
    var visibilityFrame = 0;
    var width = 0;
    var height = 0;
    var pixelRatio = 1;
    var start = performance.now();
    /*
     * The reference footer uses one high light source, not parallel beams.
     * Keep the fan intentionally uneven so it feels embedded in the woven
     * photograph instead of reading as a synthetic sunburst.
     */
    var rayPattern = [
      { target: -.16, width: .075, alpha: .15, phase: .2, drift: .70 },
      { target: -.01, width: .050, alpha: .10, phase: 2.4, drift: .52 },
      { target: .12, width: .072, alpha: .14, phase: 4.8, drift: .61 },
      { target: .25, width: .044, alpha: .09, phase: 1.3, drift: .44 },
      { target: .36, width: .066, alpha: .13, phase: 5.7, drift: .57 },
      { target: .47, width: .036, alpha: .08, phase: 3.1, drift: .36 },
      { target: .58, width: .054, alpha: .12, phase: .9, drift: .48 },
      { target: .70, width: .040, alpha: .09, phase: 4.1, drift: .40 },
      { target: .82, width: .070, alpha: .14, phase: 2.0, drift: .60 },
      { target: .96, width: .046, alpha: .10, phase: 5.2, drift: .46 },
      { target: 1.10, width: .078, alpha: .14, phase: 3.7, drift: .66 },
      { target: 1.22, width: .052, alpha: .10, phase: 1.6, drift: .50 }
    ];

    function resize() {
      var rect = footer.getBoundingClientRect();
      var nextWidth = Math.max(1, Math.round(rect.width));
      var nextHeight = Math.max(1, Math.round(rect.height));
      var nextRatio = Math.min(window.devicePixelRatio || 1, 1);

      if (nextWidth === width && nextHeight === height && nextRatio === pixelRatio) return;

      width = nextWidth;
      height = nextHeight;
      pixelRatio = nextRatio;
      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      if (visible) draw(performance.now(), true);
    }

    function paintRay(ray, time) {
      var drift = Math.sin(time * .00009 + ray.phase) * width * .010;
      var breathe = 1 + Math.sin(time * .00021 + ray.phase * 1.4) * .065;
      var sourceX = width * .515 + drift * .08;
      var targetX = ray.target * width + drift * ray.drift;
      var topHalf = width * .004;
      var bottomHalf = width * ray.width * breathe;
      var startY = -height * .12;
      var endY = height * 1.12;
      var gradient = context.createLinearGradient(sourceX, startY, targetX, endY);

      gradient.addColorStop(0, 'rgba(238, 151, 91, 0)');
      gradient.addColorStop(.16, 'rgba(238, 151, 91, ' + (ray.alpha * .32) + ')');
      gradient.addColorStop(.58, 'rgba(238, 151, 91, ' + (ray.alpha * breathe) + ')');
      gradient.addColorStop(.94, 'rgba(238, 151, 91, ' + (ray.alpha * .28) + ')');
      gradient.addColorStop(1, 'rgba(238, 151, 91, 0)');

      context.save();
      context.filter = 'blur(' + Math.max(16, width * .012) + 'px)';
      context.fillStyle = gradient;
      context.beginPath();
      context.moveTo(sourceX - topHalf, startY);
      context.bezierCurveTo(
        sourceX - topHalf * 1.6,
        height * .18,
        targetX - bottomHalf * .68,
        height * .66,
        targetX - bottomHalf,
        endY
      );
      context.lineTo(targetX + bottomHalf, endY);
      context.bezierCurveTo(
        targetX + bottomHalf * .68,
        height * .66,
        sourceX + topHalf * 1.6,
        height * .18,
        sourceX + topHalf,
        startY
      );
      context.closePath();
      context.fill();
      context.restore();
    }

    function draw(now, staticFrame) {
      context.clearRect(0, 0, width, height);
      context.globalCompositeOperation = 'screen';

      var time = reduceMotion.matches || staticFrame ? start + 3600 : now;
      rayPattern.forEach(function (ray) {
        paintRay(ray, time);
      });

      context.globalCompositeOperation = 'source-over';
    }

    function tick(now) {
      frame = 0;
      if (!visible || document.hidden || reduceMotion.matches || mobile.matches) return;
      // Slow decorative movement needs at most twelve paints per second.
      if (now - lastPaint >= 1000 / 12) {
        draw(now, false);
        lastPaint = now;
      }
      frame = requestAnimationFrame(tick);
    }

    function setAnimationState() {
      if (frame) {
        cancelAnimationFrame(frame);
        frame = 0;
      }
      if (visible) draw(performance.now(), true);
      if (visible && !document.hidden && !reduceMotion.matches && !mobile.matches) frame = requestAnimationFrame(tick);
    }

    var resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver(resize)
      : null;
    if (resizeObserver) resizeObserver.observe(footer);
    else window.addEventListener('resize', resize, { passive: true });

    // The reveal footer is fixed behind the page. IntersectionObserver regards
    // it as visible even while MainContent completely covers it. Check occlusion.
    function updateVisibility() {
      visibilityFrame = 0;
      var rect = footer.getBoundingClientRect();
      var main = document.getElementById('MainContent') || document.getElementById('btMain');
      var revealed = !document.body.classList.contains('bt-reveal') || !main || main.getBoundingClientRect().bottom < window.innerHeight;
      var nextVisible = !document.hidden && revealed && rect.bottom > 0 && rect.top < window.innerHeight;
      if (nextVisible === visible) return;
      visible = nextVisible;
      if (visible) resize();
      setAnimationState();
      canvas.style.visibility = visible ? 'visible' : 'hidden';
      footer.style.opacity = visible ? '1' : '0';
    }
    function queueVisibility() {
      if (!visibilityFrame) visibilityFrame = requestAnimationFrame(updateVisibility);
    }
    window.addEventListener('scroll', queueVisibility, { passive: true });
    window.addEventListener('resize', queueVisibility, { passive: true });
    window.addEventListener('load', queueVisibility, { once: true });
    document.addEventListener('visibilitychange', updateVisibility);
    if (mobile.addEventListener) mobile.addEventListener('change', function () { setAnimationState(); });

    var motionChange = function () { setAnimationState(); };
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', motionChange);
    else reduceMotion.addListener(motionChange);

    updateVisibility();
  }

  function initialize(scope) {
    var root = scope || document;
    if (root.matches && root.matches(SELECTOR)) createRays(root);
    Array.prototype.forEach.call(root.querySelectorAll(SELECTOR), createRays);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
